import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Products from './pages/Products';
import Cart from './pages/Cart';
import Print from './pages/Print';
import Guide from './pages/Guide';
import { useStateContext } from './contexts/ContextProvider';
import Checkout from './pages/Checkout';

function App() {
  const { handleClick } = useStateContext();
  return (
    <div className="App" onClick={handleClick}>
      <BrowserRouter>
        <Navbar />
        <Routes>
            <Route path="/" element={(<Home />)} />
            <Route path="/products" element={<Products />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/print" element={<Print />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="/checkout" element={<Checkout />} />
        </Routes>
      </BrowserRouter>
      
      
    </div>
  );
}

export default App;
